import { Form, FormProps, Select, SelectProps } from "antd";
import { useEffect, useState } from "react";
import api from "../../../common/api";
import { useTranslation } from "react-i18next";

interface IProgramSelect {
  label?: string;
  placeholder?: string;
  form?: FormProps["form"];
  name?: string;
  onSelect?: (value: any) => void;
  multiple?: boolean;
  value?: any;
  disabled?: boolean;
  [key: string]: unknown;
}

const ProgramSelect = ({
  label,
  placeholder = "Tanlang",
  form,
  name,
  onSelect,
  multiple = false,
  value,
  disabled = false,
  ...props
}: IProgramSelect) => {
  const [options, setOptions] = useState<SelectProps["options"]>([]);
  const [loading, setLoading] = useState(false);
  const { i18n } = useTranslation();
  const handleChange = (value: string[]) => {
    if (form && name) form?.setFieldValue(name, value || undefined);
    if (onSelect) onSelect(value || undefined);
  };

  const programGetAll = async () => {
    try {
      setLoading(true);
      const response = await api.programs.getPaging({ page: 1, limit: 50 });
      setOptions(
        response.data.data.map((program) => ({
          label: program.name[i18n.language as "uz" | "ru" | "en"],
          value: program._id,
        }))
      );
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    programGetAll();
  }, []);

  return (
    <Form.Item name={name} label={label} style={{ margin: 0 }} {...props}>
      <Select
        mode={multiple ? "multiple" : undefined}
        allowClear
        style={{ minWidth: "200px" }}
        placeholder={placeholder}
        onChange={handleChange}
        options={options}
        loading={loading}
        value={value}
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default ProgramSelect;
